// extracted by mini-css-extract-plugin
export var container = "styles-module--container--1kJg3";
export var inner = "styles-module--inner--2BG-d";
export var title1 = "styles-module--title1--2aD0U";
export var titleSeparate = "styles-module--titleSeparate--3EpiS";
export var title2 = "styles-module--title2--2mXgF";
export var altTitle = "styles-module--altTitle--EeIdj";
export var link = "styles-module--link--WAICl";
export var textInner = "styles-module--textInner--3AyTZ";